import Service from '../Service';
import { ResponseErrorBody, ResponseSuccessBodyLogin } from '../../types';
import Request from '../Request';
import { addFingerprintToRequest } from './utils';

export default async function(webToken: string) {
  const request = await addFingerprintToRequest(
    new Request(`/api/auth/link/${webToken}`).setMethod('GET')
  );
  const service = new Service<ResponseSuccessBodyLogin, ResponseErrorBody>(
    request
  );
  return await service.send();
}
